import { Container, Row, Col, Accordion } from "react-bootstrap";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { useSelector } from "react-redux";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";

export default function FAQ() {
  const { isAuth } = useSelector((state) => state.auth);
  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main pt-0">
        <Container>
          <Row>
            <Col>
              <div className="foot-static-page">
                <h4 className="footPageTitle">
                  Frequently Asked Questions About Indi365
                </h4>
                <div className="FaqSection">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      {/* <Accordion.Header>Frequently Asked Questions About Indi365</Accordion.Header> */}
                      <Accordion.Header>
                        1. What is the purpose of registering?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Registering on the Indi365 website is essential to
                            access and use any of our services. Creating an
                            account is completely free and comes with no
                            obligations. Once registered, you’ll be able to
                            manage your personal details and betting activities.
                            After funding your account, you can begin placing
                            real-money bets.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        2. How do I sign up on Indi365?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            To register, simply click the "Register" button
                            located in the top-right corner of our homepage.
                            Please ensure that all the required information is
                            filled out correctly, and review our registration
                            guidelines to avoid any future issues. We also
                            recommend that you familiarize yourself with our
                            terms and conditions beforehand.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        3. Why do I need to provide personal information during
                        registration?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Providing accurate personal information is crucial
                            for your safety and the security of your account.
                            Managing your Indi365 account is similar to handling
                            a bank account. We require:
                          </p>
                          <ul>
                            <li>
                              <b>Full name</b> and <b>current address</b> for
                              identity verification.
                            </li>
                            <li>
                              <b>Date of birth</b> to confirm you are of legal
                              age to use our services.
                            </li>
                            <li>
                              <b>Email address</b> for account-related
                              communication, including password recovery and
                              notifications.
                            </li>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        4. Is passport information required? If so, why?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Yes, passport or valid ID information is mandatory
                            for security purposes. This step ensures identity
                            verification and is necessary for processing
                            withdrawals, especially when claiming winnings.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        5. Where can I find my account number?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Your unique account ID is available under the{" "}
                            <b>"My Data"</b>section on the <b>"My Profile"</b>
                            page.
                          </p>
                          <p>
                            Example: <b>ID: 19</b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        6. Does registering on Indi365 create any obligations
                        for me?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            {" "}
                            No, registering on Indi365 does<b>not</b>obligate
                            you to make deposits or place a minimum number of
                            bets. However, by registering, you agree to abide by
                            our<b>General Terms and Conditions.</b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        7. Can I update my personal information after
                        registration?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Some fundamental details—such as your{" "}
                            <b>
                              {" "}
                              first and last name, date of birth, account
                              currency,
                            </b>
                            and <b>country settings—</b>
                            cannot be edited after registration due to security
                            and integrity policies. However, you can still
                            update other personal details.
                          </p>
                          <p>
                            In exceptional cases (e.g., incorrect information
                            entered during sign-up), you may submit valid
                            supporting documents. Indi365 will then review your
                            request and may approve changes to your core
                            information.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                        8. Am I required to deposit funds immediately after
                        registering?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            No, there is <b> no obligation</b> to make a deposit
                            right after registering. You may fund your account
                            at any time by using the <b>"Deposit"</b>
                            option when you're ready.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                        9. What should I do if I forget my account credentials
                        or password?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Use the <b> "Forgot Password?" </b> link on our
                            website to recover your login information. If
                            recovery fails (e.g., due to an incorrect email
                            address or technical issue), please{" "}
                            <b> contact our support team</b> for further
                            assistance.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="9">
                      <Accordion.Header>
                        10. Can someone else access my account?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Yes, this is possible if you close the browser
                            window using the "X" button
                            <b> without logging out properly. </b>Always use the{" "}
                            <b> "Log Out"</b>
                            option to protect your account.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        11. What if someone else discovers my login or password?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            If you believe your login credentials have been
                            compromised,
                            <b>contact our support team immediately.</b>We will
                            temporarily block your account to prevent
                            unauthorized access and investigate the issue. For
                            added security, make sure your registered email is
                            up-to-date and monitored regularly.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        12. How Do I Verify My Indi365 Account?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            To verify your account, you’ll need to provide
                            documents under three main categories:
                            <b>Proof of Identity, Proof of Address,</b>and{" "}
                            <b>Proof of Payment Method.</b>This process helps
                            ensure the security and integrity of your account.
                          </p>
                          <div className="AccordionPart">
                            <div>
                              <h3>1. Proof of Identity</h3>
                              <p>
                                Please submit <b>one</b> of the following valid
                                documents:
                              </p>
                              <ul>
                                <li>
                                  A full double-page scan of your{" "}
                                  <b>passport</b>
                                </li>
                                <li>
                                  Both sides of a <b>national identity card</b>
                                </li>
                                <li>
                                  Both sides of a <b>valid driver’s license</b>
                                </li>
                                <li>
                                  A <b>residency permit</b>
                                </li>
                              </ul>
                              <p>
                                ⚠️ Note: Other documents (e.g., handwritten
                                notes or rental agreements) will not be accepted
                                as proof of identity.
                              </p>
                            </div>
                            <div>
                              <h3>2. Proof of Address</h3>
                              <p>
                                Provide a <b>clear, full-page document</b>{" "}
                                (dated within the last 3 months) showing your
                                name and current residential address. Acceptable
                                documents include:
                              </p>
                              <ul>
                                <li>
                                  <b>Bank account statement</b>
                                </li>
                                <li>
                                  <b>Utility bill </b> for fixed-line services
                                  (electricity, gas, water, landline phone){" "}
                                </li>
                                <li>
                                  A <b>residency permit</b>
                                </li>
                                <li>
                                  A <b>driver’s license</b>(both sides, if
                                  showing your current address)
                                </li>
                                <li>
                                  An <b>official letter</b>from a government
                                  body, verified by local authorities
                                </li>
                              </ul>
                              <p>
                                ❗ Make sure the address on your document
                                matches the address in your Indi365 profile.
                                Please exclude sensitive information such as
                                account balances or credit card numbers.
                              </p>
                            </div>
                            <div>
                              <h3>3. Proof of Payment Method</h3>
                              <p>
                                To confirm your payment method, submit a{" "}
                                <b>color screenshot or scan</b>
                                showing complete and clear details based on your
                                payment type:
                              </p>
                              <ul className="AccordionSubPart">
                                <h5>a. Credit or Debit Card</h5>
                                <li>
                                  Upload images of both front and back of the
                                  card.
                                </li>
                                <li>
                                  Only the <b>first six and last four digits</b>
                                  should be visible.
                                </li>
                                <li>
                                  <b>Cover the CVV/CVC</b>code on the back.
                                </li>
                                <li>Ensure all four corners are visible.</li>
                                <li>
                                  Your <b>signature must appear</b>on the card.
                                </li>
                              </ul>
                              <ul className="AccordionSubPart">
                                <h5>b. Bank Transaction</h5>
                                <p>
                                  Submit <b>one</b> of the following:
                                </p>
                                <li>
                                  A<b>clear photo or scan</b> of a paper bank
                                  statement
                                </li>
                                <li>
                                  A <b> screenshot from your online banking</b>{" "}
                                  showing account details and a transaction
                                </li>
                              </ul>
                              <ul className="AccordionSubPart">
                                <h5>c. E-wallets (e.g., Skrill, Neteller)</h5>
                                <li>
                                  Provide a<b>screenshot</b> of your full{" "}
                                  <b>profile page</b>
                                  showing your <b>full name</b> and{" "}
                                  <b>account information.</b>
                                </li>
                              </ul>
                              <ul className="AccordionSubPart">
                                <h5>d. Voucher (e.g., Paysafecard)</h5>
                                <li>
                                  Upload a <b> clear scan</b> or image of your{" "}
                                  <b>voucher or receipt.</b>
                                </li>
                                <li>
                                  Remove any sensitive or unrelated information.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="12">
                      <Accordion.Header>
                        13. Document Guidelines
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <ul>
                            <li>
                              Files must be in <b>color</b> and clearly show{" "}
                              <b>all four corners.</b>
                            </li>
                            <li>
                              Accepted formats:{" "}
                              <b>DOC, DOCX, PDF, JPG, JPEG, PNG, BMP, TIFF</b>
                            </li>
                            <li>
                              Minimum resolution: <b>320 DPI</b>
                            </li>
                            <li>
                              Maximum file size: <b>8 MB</b>
                            </li>
                            <li>
                              File names should clearly describe the document
                              type (e.g.,
                              <span>
                                ID, Proof_of_Address, Bank_Statement,
                                Credit_Card).
                              </span>
                            </li>
                          </ul>
                          <p className="mt-5">
                            ✅ Tip: Digital photos and screenshots are accepted
                            if they are clear and readable.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="13">
                      <Accordion.Header>
                        14. Placing & Settling Bets
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <ul>
                            <h3>1. How Do I Place a Bet?</h3>
                            <p>
                              To place a bet on Indi365, follow these simple
                              steps:
                            </p>
                            <ol>
                              <li>
                                {" "}
                                <b>Log in</b> using your username and password.
                              </li>
                              <li>
                                {" "}
                                Browse our available events and{" "}
                                <b>select one or more outcomes</b>
                                by clicking on your preferred predictions.
                              </li>
                              <li>
                                {" "}
                                Your selections will automatically appear on the{" "}
                                <b>bet slip</b> located on the right side of the
                                screen.
                              </li>
                              <li>
                                Enter your <b>stake amount</b>and choose your
                                preferred
                                <b> type of bet:</b>
                                <ul>
                                  <li>Single</li>
                                  <li>Express</li>
                                  <li>System</li>
                                  <li>Chain</li>
                                </ul>
                              </li>
                              <li>
                                In the final step, confirm your wager. You can
                                choose to
                                <b>accept or cancel</b> the bet before
                                finalizing.
                              </li>
                            </ol>
                            <p>
                              ⚠️ Important: Once a bet has been placed and
                              confirmed, it cannot be canceled according to our
                              General Terms and Conditions (GTCs).
                            </p>
                          </ul>

                          <ul>
                            <h3>2. What Types of Bets Are Available?</h3>
                            <p>
                              Indi365 offers several types of betting options to
                              suit your style:
                            </p>
                            <ol>
                              <li>
                                <b>Single Bet:</b> A bet placed on one
                                prediction. If the outcome is correct, the bet
                                wins.
                              </li>
                              <li>
                                <b>Express Bet:</b> A bet that includes two or
                                more selections. All selections must win for the
                                bet to be successful.
                              </li>
                              <li>
                                <b>System Bet:</b> A combination of multiple
                                selections arranged into smaller combinations.
                                You don't need all predictions to be correct to
                                receive a payout.
                              </li>
                              <li>
                                <b>Chain Bet: </b>A sequence of single bets that
                                are settled one after another using your initial
                                stake.
                              </li>
                            </ol>
                          </ul>

                          <ul>
                            <h3>3. What Is a “Single” Bet?</h3>
                            <p>
                              A <b>Single</b> bet is the most straightforward
                              type of wager. You make one prediction, set your
                              stake, and place the bet.
                            </p>
                            <p>
                              If your prediction is correct, you win the bet.
                              Your payout is calculated by multiplying the{" "}
                              <b>odds</b>by your <b>stake</b>
                            </p>
                          </ul>

                          <ul>
                            <h3>
                              4. What Can Be Included in an “Express” Bet?
                            </h3>
                            <p>
                              An <b>Express</b> bet combines two or more
                              individual selections into one wager. The majority
                              of available bets on Indi365 can be included in an
                              Express bet. However, there are exceptions—for
                              example, certain Formula 1 bets that may only be
                              placed as Singles.
                            </p>
                            <p>
                              ⚠️ The ability to combine specific bets into an
                              Express is determined by the bookmaker and may
                              depend on the sport, event, or market.
                            </p>
                            <p>
                              You will be informed during the betting process if
                              certain selections
                              <b>cannot be combined.</b> Also, please note:
                            </p>
                            <ol>
                              <li>
                                You <b>cannot</b>place multiple Express or
                                System bets on the
                                <b> same event or outcome.</b>
                              </li>
                            </ol>
                          </ul>

                          <ul>
                            <h3>
                              5. What Is a “System” Bet and How Is It
                              Calculated?
                            </h3>
                            <p>
                              A <b>System</b> bet includes three or more events
                              and creates multiple combinations of those
                              selections.
                            </p>
                            <p>
                              <b>For example:</b>If you choose a{" "}
                              <b>2/5 system,</b>it means that out of 5 total
                              selections, any 2 correct predictions will result
                              in a winning combination.
                            </p>
                            <p>
                              Each combination is treated as a separate bet, and
                              your winnings depend on how many of those
                              combinations are successful.
                            </p>
                            <p>
                              💡 The <b>minimum stake per combination</b>{" "}
                              depends on the type of system chosen.
                            </p>
                          </ul>

                          <ul>
                            <h3>6. What does "Handicap" mean?</h3>
                            <p>
                              A <b>handicap</b> is a virtual advantage or
                              disadvantage applied to a team or player,
                              expressed in terms of goals, points, sets, or
                              frames. It can be{" "}
                              <b> positive, negative, or zero</b>For example:
                            </p>
                            <li>
                              A bet on "Handicap 1(2)" in a football match gives
                              Team 1 a two-goal advantage.
                              <ul>
                                <li>
                                  If the actual score is 1-1, the result with
                                  the handicap becomes 3-1 — the bet{" "}
                                  <b>wins.</b>
                                </li>
                                <li>
                                  If the actual score is 0-3, the result becomes
                                  2-3 — the bet
                                  <b>loses.</b>
                                </li>
                                <li>
                                  If the actual score is 0-2, the result becomes
                                  2-2 — the bet is a<b>push</b>void.
                                </li>
                              </ul>
                            </li>
                            <p>
                              <b>Negative handicaps</b> subtract points from the
                              favored team, and are settled similarly.
                            </p>
                            <p>Here are more examples:</p>
                            <ul>
                              <li>
                                <b>W1 Handicap (-1) </b>wins only if Team 1 wins
                                by <b>two or more goals.</b>
                              </li>
                              <li>
                                <b>W2 Handicap (1) </b>wins if Team 2 wins or{" "}
                                <b>draws.</b>
                              </li>
                              <li>
                                <b>X Handicap (1) </b>wins if Team 1{" "}
                                <b>wins by one</b>0r Team 2 <b>loses by one.</b>
                              </li>
                              <li>
                                <b>W2 Handicap (2) </b>wins if
                              </li>
                              <ul>
                                <li>
                                  The match ends in a <b>draw</b>
                                </li>
                                <li>
                                  Team 1 wins by <b>one goal</b>
                                </li>
                                <li>
                                  Team 2 <b>wins</b>
                                </li>
                              </ul>
                              <li>
                                <b>X Handicap (2) </b>wins if Team 1 wins by
                                <b>exactly two goals.</b>
                              </li>
                              <li>
                                <b>X Handicap (+2) </b>wins if Team 2 wins by
                                <b>exactly two goals.</b>
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="14">
                      <Accordion.Header>
                        15. What is a "Hat-trick"?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            A <b>Hat-trick</b>bet is successful when a player
                            from either team scores <b>three or more goals</b>{" "}
                            during a single match.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="15">
                      <Accordion.Header>
                        16. What do W1W2, W1X, W2W2 and similar bets mean?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            These bets indicate results at{" "}
                            <b>half-time and full-time:</b>
                          </p>
                          <ul>
                            <li>
                              <b>W1W2: </b>Team 1 wins the first half, but Team
                              2 wins the match.
                            </li>
                            <li>
                              <b>W1X: </b> Team 1 wins the first half, and the
                              match ends in a draw
                            </li>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="16">
                      <Accordion.Header>
                        17. Why do I get a "win limit exceeded" message when
                        placing a bet?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Our bookmakers may <b>apply maximum win limits</b>{" "}
                            per bet. If your wager exceeds this limit, you’ll be
                            notified. Limits can vary depending on betting
                            volume and event type. If limits are temporarily
                            reduced, try placing the same bet again—although
                            odds may have changed.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="17">
                      <Accordion.Header>
                        18. What is the minimum and maximum bet amount?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            - <b>Minimum bet: </b>$0.10
                          </p>
                          <br />
                          <p>
                            - <b>Maximum bet:</b>Determined by maximum winnings
                            allowed per bet. If your stake exceeds this, reduce
                            it accordingly.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="18">
                      <Accordion.Header>
                        19. What are the maximum odds for System or Express
                        bets?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            The <b>maximum allowed odds</b> for Express and
                            System bets are <b>1000.</b>
                            Any odds above this will be calculated as 1000.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="19">
                      <Accordion.Header>
                        20. How can I remove a prediction from my bet slip?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Click the <b>“X”</b> next to the selection in your
                            bet slip to delete it.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="20">
                      <Accordion.Header>
                        21. I placed a bet by mistake. Can I cancel it?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Unfortunately, bets <b>cannot be cancelled</b> once
                            placed, in accordance with our General Terms and
                            Conditions. You can cancel a bet <b>before</b>
                            confirmation, but once it appears in your "My Bets"
                            section, it is considered final.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="21">
                      <Accordion.Header>
                        22. How do I know if my bet was accepted?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Once you click <b>“Make a Bet”,</b> you will receive
                            a <b>confirmation message</b>
                            if your bet is successfully placed. You can also
                            check the <b>“Bet History”</b>
                            in your account.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="22">
                      <Accordion.Header>
                        23. When does the operator cancel bets?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Bets may be cancelled due to incorrect:
                            <ul>
                              <li>Player or team names</li>
                              <li>Odds</li>
                              <li>Totals or handicaps</li>
                              <li>Other critical information</li>
                            </ul>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="23">
                      <Accordion.Header>
                        24. What if a match is postponed or cancelled?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            If a match is postponed or cancelled, bets are
                            settled as <b>void</b>
                            according to the rules of each sport. For Express or
                            System bets, the affected selection is also
                            considered void.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="24">
                      <Accordion.Header>
                        25. How are football matches with overtime or penalties
                        settled?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Unless stated otherwise, bets are settled based on
                            the result after <b>90 minutes,</b>
                            including stoppage time.{" "}
                            <b>
                              Overtime and penalty shootouts are not included.
                            </b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="25">
                      <Accordion.Header>
                        26. What happens if a player receives two yellow cards?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            A player who receives two yellow cards is considered
                            to have:
                          </p>
                          <ul>
                            <li>
                              <b>1 Yellow card</b>
                            </li>
                            <li>
                              <b>1 Red card</b> (from the second yellow)
                            </li>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="26">
                      <Accordion.Header>
                        27. How are basketball games settled?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            - <b>Overtime</b> is included for most basketball
                            bets unless otherwise stated.
                          </p>
                          <br />
                          <p>
                            - If a “draw” is offered for regular time only,
                            overtime is
                            <b>not included.</b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="27">
                      <Accordion.Header>
                        28. How are hockey bets settled?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Bets are settled based on the{" "}
                            <b>official match duration,</b>
                            unless stated otherwise.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="28">
                      <Accordion.Header>
                        29. What happens if a tennis player retires or is
                        disqualified?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            If a tennis player is unable to continue, they are
                            considered to have{" "}
                            <b>lost all remaining games and sets, </b> and bets
                            are settled based on the <b>final outcome.</b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="29">
                      <Accordion.Header>
                        30. Do I get a refund if a match isn’t played?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Yes. Bets are refunded if the event doesn’t take
                            place within <b>24 hours,</b>
                            unless the outcome was already determined.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="30">
                      <Accordion.Header>
                        31. Why is my bet taking long to settle?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Bet settlement is usually quick, but may be delayed
                            due to:
                          </p>
                          <ul>
                            <li>Lack of official results</li>
                            <li>
                              Conflicting information from different sources
                            </li>
                            <li>Technical issues</li>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="31">
                      <Accordion.Header>
                        32. What should I do if the odds for my bet were
                        incorrect?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Contact <b>Live Support.</b> Our team will review
                            the bet. If it was miscalculated, the correct
                            winnings will be credited.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="32">
                      <Accordion.Header>
                        33. What is the minimum duration for a game to be valid
                        for betting?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            A game is considered valid if the following time
                            minimums are met:
                          </p>
                          <ul>
                            <li>
                              Football: <b>90 minutes</b>
                            </li>
                            <li>
                              Futsal: <b>35 minutes</b>
                            </li>
                            <li>
                              NBA: <b>43 minutes</b>
                            </li>
                            <li>
                              Euro Basketball: <b>35 minutes</b>
                            </li>
                            <li>
                              NHL: <b>50-55 minutes</b>
                            </li>
                            <li>
                              Bandy: <b>60 minutes</b>
                            </li>
                            <li>
                              American Football: <b>60 minutes</b>
                            </li>
                            <li>
                              Baseball: <b>5 innings</b>
                            </li>
                            <li>
                              Handball: <b>50 minutes</b>
                            </li>
                          </ul>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="33">
                      <Accordion.Header>
                        34. What happens if a game is postponed?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            If a match isn’t played within <b>30 hours,</b> your
                            bet will be <b>refunded</b> or settled as{" "}
                            <b>void.</b> For multi-bets or system bets, the odds
                            of the postponed game are set to <b>1.00.</b>
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="34">
                      <Accordion.Header>
                        35. How can I check the outcome of a match?
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Visit the <b>official sources</b> listed in section
                            18.3 of our Terms and Conditions. Indi365 uses these
                            sources to settle bets accurately.
                          </p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="35">
                      <Accordion.Header>36. Live Wagers</Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <p>
                            Experience the thrill of real-time betting with{" "}
                            <b>LIVE wagers</b> on Indi365. As the match unfolds,
                            you and hundreds of other fans can place bets
                            dynamically. Odds update live based on the event’s
                            progress, with real-time data including current
                            scores, yellow/red cards, and more. LIVE betting is
                            available not just for football, but also for
                            tennis, Formula 1, American football, ice hockey,
                            skiing, and more.
                          </p>
                          <ol>
                            <li>
                              Why was there a delay or interruption in accepting
                              my wager?
                              <p>
                                Several factors may cause interruptions or
                                delays in bet acceptance:
                              </p>
                              <ul>
                                <li>
                                  Technical issues such as live broadcast
                                  disruptions, software failures, or power
                                  outages.
                                </li>
                                <li>
                                  A surge in the number of bets being placed
                                  simultaneously.
                                </li>
                                <li>
                                  Increased user activity during high-stakes or
                                  popular events.
                                </li>
                                <li>
                                  Network congestion due to heavy traffic.
                                </li>
                                <li>
                                  Fast-paced events, like tennis, where outcomes
                                  change quickly and odds fluctuate rapidly.
                                </li>
                              </ul>
                            </li>

                            <li>
                              Why did my wager appear twice?
                              <p>
                                This usually occurs if the "Place Bet" button is
                                clicked more than once. Please double-check
                                before confirming your wager.
                              </p>
                            </li>
                            <li>
                              Why were wagers on an event suspended before it
                              started?
                              <p>
                                Suspensions may occur due to high betting volume
                                or technical system triggers related to event
                                data or odds fluctuations.
                              </p>
                            </li>
                            <li>
                              How accurate is the live information displayed on
                              your site?
                              <p>
                                While we strive to ensure all live data (scores,
                                stats, etc.) is accurate and up-to-date, it
                                should be treated as a <b>reference only</b>{" "}
                                when placing bets.
                              </p>
                            </li>
                            <li>
                              Why was my live betting limit reduced?
                              <p>
                                The betting office reserves the right to adjust
                                individual or global betting limits without
                                prior notice. In certain cases, access to
                                services may be restricted for specific accounts
                                without an obligation to provide a reason.
                              </p>
                            </li>
                          </ol>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="36">
                      <Accordion.Header>37. Casino</Accordion.Header>
                      <Accordion.Body>
                        <div className="OneAccordion">
                          <ol>
                            <li>
                              How do I open a casino account?
                              <p>
                                To access the Indi365 Casino, you’ll need an
                                active Indi365 account. Click <b>“Register”</b>{" "}
                                on the casino homepage and follow the easy
                                registration steps.
                              </p>
                            </li>
                            <li>
                              How do I deposit money into the casino?
                              <p>Once logged in:</p>
                              <ul>
                                <li>
                                  Click on your profile picture at the top of
                                  the page.
                                </li>
                                <li>
                                  Select <b>“Deposit”,</b> then choose your
                                  preferred amount and payment method.
                                </li>
                              </ul>
                            </li>
                            <li>
                              How do I view recently played games?
                              <p>
                                After logging in, navigate to the bottom of the
                                Casino page. Use the game icons to access your{" "}
                                <b>recently played games</b> list.
                              </p>
                            </li>
                            <li>
                              What is a Random Number Generator (RNG)?
                              <p>
                                {" "}
                                The <b>Random Number Generator (RNG)</b> is a
                                computer algorithm that ensures fair and
                                unbiased game outcomes. Whether it's a card
                                draw, dice roll, or any game mechanic, RNG
                                produces results randomly with no repetition or
                                predictability—guaranteeing fair gameplay every
                                time.
                              </p>
                            </li>
                            <li>
                              What types of games are available in the Indi365
                              Casino?
                              <p>At Indi365 Casino, you can enjoy:</p>
                              <ul>
                                <li>A wide variety of 3D games</li>
                                <li>Classic and modern slot games</li>
                                <li>Popular table games</li>
                                <li>
                                  Live dealer games like <b>Blackjack</b> and{" "}
                                  <b>Roulette</b>
                                </li>
                                <li>
                                  <b>Baccarat</b> (coming soon)
                                </li>
                              </ul>
                            </li>
                          </ol>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </main>

      {isAuth ? <Footer /> : <BeforeLoginFooter />}
    </>
  );
}
